export const apiMethods = [
    {
        name: 'GetActiveGames',
        method: 'getPromotionGames',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'GetBanners',
        method: 'getcarousels',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'GetConfig',
        method: 'getconfigs',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'GetDrawings',
        method: 'getdrawingsandwinners',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'promotion_id',
                processArgs: (val) => val,
            },
            {
                name: 'draw_date',
                processArgs: (val) => val,
            },
            {
                name: 'view',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'GetPromotions',
        method: 'getpromotions',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'GetPromotionDetail',
        method: 'getpromotions',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'promotion',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'PlayerLogin',
        method: 'PlayerLogin',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'email',
                processArgs: (val) => val,
            },
            {
                name: 'password',
                processArgs: (val) => btoa(val), // base64 encode the password
            },
            {
                name: 'terms_check',
                processArgs: (val) => val,
            },
            {
                name: 'form_submitted',
                processArgs: () => 1,
            },
        ],
    },
    {
        name: 'MyEntries',
        method: 'MyEntries',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'promotion_id',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'page',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'limit',
                processArgs: (val) => {
                    return val;
                },
            },
        ],
    },
    {
        name: 'PlayerData',
        method: 'PlayerData',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'PlayerLogout',
        method: 'PlayerLogout',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'SetEntryFlashGameFlag',
        method: 'setentryflashgameflag',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: (val) => val,
            },
            {
                name: 'entry_id',
                processArgs: (val) => val,
            },
            {
                name: 'flag',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'Winners',
        method: 'Winners',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: (val) => val,
            },
            {
                name: 'draw_number',
                processArgs: (val) => val,
            },
            {
                name: 'draw_date',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'PlayerCancelToken',
        method: 'PlayerCancelToken',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'PlayerCancel',
        method: 'PlayerCancel',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'token',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'SetEntryFlashGameFlag',
        method: 'SetEntryFlashGameFlag',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'entry_id',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'Feedback',
        method: 'postfeedback',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'name',
                processArgs: (val) => val,
            },
            {
                name: 'email',
                processArgs: (val) => val,
            },
            {
                name: 'promotion_id',
                processArgs: (val) => val,
            },
            {
                name: 'comments',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'ValidateTicket',
        method: 'ValidateTicket',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'ticket1_1_1',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'ticket1_1_2',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'ticket1_2_1',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'entry_method',
                processArgs: (val) => {
                    return val || '';
                },
            },
            {
                name: 'form_submitted',
                processArgs: (val) => {
                    return '1';
                },
            },
            {
                name: 'entry-submit',
                processArgs: (val) => {
                    return 'SUBMIT+ENTRY';
                },
            },
            {
                name: 'promotion',
                processArgs: (val) => {
                    return val;
                },
            },
            {
                name: 'promotion_game_id',
                processArgs: (val) => {
                    return val;
                },
            },
        ],
    },
];
